import {
  GET_REGIONS,
  GET_REGIONS_ERROR,
  GET_REGIONS_SUCCESS,
  GET_USER_UNITS,
  GET_USER_UNITS_ERROR,
  GET_USER_UNITS_SUCCESS
} from './ConfigProvider.actions'

const configState = {
  regionInfo: {
    error: false,
    loading: false,
    regions: []
  },
  userUnitsInfo: {
    error: false,
    loading: false,
    units: []
  }
}

const configProviderReducer = (state = configState, { payload, type }) => {
  switch (type) {
    case GET_REGIONS: {
      return { ...state, regionInfo: { error: false, loading: true } }
    }
    case GET_REGIONS_ERROR: {
      return { ...state, regionInfo: { error: true, loading: false } }
    }
    case GET_REGIONS_SUCCESS: {
      return { ...state, regionInfo: { ...state.regionInfo, error: false, loading: false, regions: payload.regions } }
    }
    case GET_USER_UNITS: {
      return { ...state, userUnitsInfo: { error: false, loading: true } }
    }
    case GET_USER_UNITS_ERROR: {
      return { ...state, userUnitsInfo: { error: true, loading: false } }
    }
    case GET_USER_UNITS_SUCCESS: {
      return { ...state, userUnitsInfo: { ...state.userUnitsInfo, units: payload.userUnits, loading: false } }
    }
    default: {
      return state
    }
  }
}

export default configProviderReducer
